module.exports = __webpack_public_path__ + "assets/img/nav-item-1-cb9e439d.png";